document.addEventListener('DOMContentLoaded', function() {
    const menuItems = document.querySelectorAll('[menu-label]');
    const imageCards = document.querySelectorAll('[menu-label-item]');
    const defaultCard = document.querySelector('[menu-label-item="default"]');

    // Safety check: only run if we have menu items and cards
    if (menuItems.length === 0 || imageCards.length === 0) {
        console.warn('Missing menu items or image cards in the DOM.');
        return;
    }

    function handleMenuHover(event) {
        const menuLabel = event.target.getAttribute('menu-label');
        if (!menuLabel) return;

        const matchingCard = document.querySelector(`[menu-label-item="${menuLabel}"]`);

        // Hide all cards first (only if cards exist)
        imageCards.forEach(card => {
            if (card) {
                card.classList.remove('active');
                card.classList.add('hide');
            }
        });

        // Show the matching card or default (only if it exists)
        if (matchingCard) {
            matchingCard.classList.remove('hide');
            matchingCard.classList.add('active');
        } else if (defaultCard) {
            defaultCard.classList.remove('hide');
            defaultCard.classList.add('active');
        } else {
            console.warn(`No matching card or default card found for: ${menuLabel}`);
        }
    }

    // Attach event listeners safely
    menuItems.forEach(item => {
        if (item) {
            item.addEventListener('mouseenter', handleMenuHover);
      //    item.addEventListener('mouseleave', resetToDefault);
        }
    });

     // Add hover interaction for desktop mega menu tabs
    const tabTriggers = document.querySelectorAll('.mega-menu-4__tab-trigger');
    tabTriggers.forEach(trigger => {
        if (trigger) {
            trigger.addEventListener('mouseenter', function() {
                this.click(); // Trigger the default xo-tabs click behavior on hover
            });
        }
    });
});

// mega menu dropdown link click remove
// document.addEventListener('DOMContentLoaded', function() {
//   const linksToDisable = document.querySelectorAll('.js-remove-link');
  
//   linksToDisable.forEach(function(link) {
//     let menuTile = link.closest('a')
//     menuTile.addEventListener('click', function(event) {
//       event.preventDefault();
//     });
//   });
// });